import React from 'react';

import { isDescriptionEmpty } from '../../pages/EditOpportunity/PublicationForm/PublicationInfoForm';
import { AIAlert } from '../components/AIAlert';
import { ACTION_GENERATE_JOB_POSTING_DESCRIPTION } from '../constants/actions';
import { aiPurple } from '../constants/colors';
import { GenerateOpportunityDescriptionButton } from '../generate_text/TextOverwriteWithAIGenerated';
import useAsyncSinapseResponse, {
  AsyncSinapseResponseHookProps,
} from '../hooks/useAsyncSinapseResponse';
import { SparkIcon } from '../icons/spark';

const getQueryKeyPath = (sourceId: number) => ['sinapse', 'opportunityDescription', sourceId];
export const useGenerateOpportunityDescriptionStatus = (sourceId?: number) => {
  const { responseStatus: responseTextStatus } = useAsyncSinapseResponse({
    sourceId,
    action: ACTION_GENERATE_JOB_POSTING_DESCRIPTION,
    enabled: !!sourceId,
    configs: {
      queryKeyPath: sourceId ? getQueryKeyPath(sourceId) : undefined,
    },
  });
  return responseTextStatus;
};
export const OpportunityDescriptionGenerator: React.FC<AsyncSinapseResponseHookProps> = ({
  enabled,
  setIsDisabledInput,
  setResult,
  sourceId: opportunityId,
  textValue = '',
}) => {
  const {
    discartResponseResult: discartResponseText,
    processResult,
    responseStatus,
  } = useAsyncSinapseResponse({
    setIsDisabledInput,
    setResult,
    sourceId: opportunityId,
    textValue,
    action: ACTION_GENERATE_JOB_POSTING_DESCRIPTION,
    enabled,
    configs: {
      overwriteOnSuccess: true,
      queryKeyPath: opportunityId ? getQueryKeyPath(opportunityId) : undefined,
    },
  });

  if (!enabled) {
    return null;
  }

  return (
    <>
      <AIAlert
        key="ai-alert-optimize-text"
        showIcon
        icon={<SparkIcon style={{ fontSize: '1.5em', color: aiPurple }} />}
        action={
          <GenerateOpportunityDescriptionButton
            discartResponseText={
              // confirm fn
              discartResponseText
            }
            processText={processResult} // initiator
            responseTextStatus={responseStatus} // state
            textValue={textValue}
            isTextEmpty={isDescriptionEmpty}
          />
        }
        message={
          <>
            <b>Descrição da vaga:</b> Utilize a Synapses para gerar automaticamente a descrição da
            vaga com base nas informações preenchidas.
          </>
        }
      />
    </>
  );
};
